module.exports = __webpack_public_path__ + "static/media/errorWhite.88262e4d.svg";